export const MAX_TERMS_IN_SYNONYM = 500;
export const MIN_TERMS_IN_SYNONYM = 2;
export const MIN_SYNONYM_WORD_CHARACTER_COUNT = 1;
export const MAX_SYNONYM_WORD_CHARACTER_COUNT = 256;
